import React from 'react';
import { BrowserRouter, Routes, Route , Navigate  } from "react-router-dom";

import Layout from './Layout';
import About from './About';
import Contact from './Contact';
import Error from './Error';
import User from './User';
import Search from './Search';

const Page = () => {
  return (<>
 <div style={{height:"500px"}}>
  <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/about" element={<About />} />
          <Route path="/search" element={<Search />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/user/:fname/:lname" element={<User />} />
          {/* <Route path='*' element={<Error />} /> */}
          <Route path='*' element={<Navigate to="/" replace={true} />} />
        </Route>
      </Routes>
    </BrowserRouter>

</div>
      {/* <About />
      <Contact /> */}
  </>);
};

export default Page;
